import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './login-failed.component.html',
  styleUrls: ['login-failed.component.scss'],
  imports: [
    MatButton,
    RouterLink,
  ],
})
export class LoginFailedComponent {
}
